"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var DecoderHint = function () {
  function e(e, t, s, i) {
    this.code = t, this.message = s, this.debugInfo = i, this.strings = e;
  }

  return e.prototype.description = function () {
    return "code: " + this.code + ", message: " + this.message;
  }, e.prototype.localizedMessage = function () {
    return this.strings.localized(this.code);
  }, e;
}();

exports.default = DecoderHint;